import { SurveySection } from '../../entities/survey_engine/SurveySection';

export function filterDefaultFlowSections(sections: SurveySection[]) {
  return sections.filter((section) =>
    section.questions.some((question) => question.default_flow),
  );
}
